import React, { useCallback } from 'react';
import modalStyles from '@/common/styles/modal-form-primary.less';
import { DecedentMainInfo } from '@/common/containers/Forms/index';
import Modal from '@/common/components/Modal/index';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useEditDecedentMutation } from '@/entities/decedent';

const INITIAL_VALUES = {
  firstName: '',
  lastName: '',
  middleName: '',
  socialInsuranceNumber: '',
  localHealthNumber: '',
  dateOfBirth: '',
  countryOfBirth: 'Canada',
  cityOfBirth: '',
  provinceOfBirth: '',
  dateOfDeath: '',
  countryOfDeath: 'Canada',
  cityOfDeath: '',
  provinceOfDeath: '',
};

const EditDecedentMainInfo = ({ open = true, onClose, decedent, onSubmit }) => {
  const { t } = useTranslation();
  const editDecedentMutation = useEditDecedentMutation();
  const loading = editDecedentMutation.isPending;
  const submitHandler = onSubmit || editDecedentMutation.mutateAsync;
  const submitEdit = useCallback(
    (form) => {
      submitHandler({ id: decedent.id, form }).then(() => onClose());
    },
    [decedent?.id, onClose, submitHandler]
  );

  return (
    <Modal className={modalStyles.modal} open={open} overlay>
      <div className={modalStyles.modalHeader}>
        <h3>{t('Edit decedent info')}</h3>
      </div>
      <div className={modalStyles.modalForm}>
        <DecedentMainInfo
          className={modalStyles.modalBody}
          initialValues={decedent || INITIAL_VALUES}
          onSubmit={submitEdit}
          formId="editDecedent"
        />
        <div className={modalStyles.modalFooter}>
          <div className={modalStyles.modalFooterBtns}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onClose}
              disabled={loading}
            >
              {t('Cancel')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              loading={loading}
              form="editDecedent"
            >
              {t('Save')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditDecedentMainInfo;
